import { render, staticRenderFns } from "./PluskaLogo.vue?vue&type=template&id=0435dd4a&scoped=true"
import script from "./PluskaLogo.vue?vue&type=script&lang=js"
export * from "./PluskaLogo.vue?vue&type=script&lang=js"
import style0 from "./PluskaLogo.vue?vue&type=style&index=0&id=0435dd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435dd4a",
  null
  
)

export default component.exports